export enum MarketplaceErrorType {
    Unknown = 'Unknown'
}

export class MarketplaceError extends Error {
    name = 'MarketplaceError';
    type: MarketplaceErrorType;

    constructor(type: MarketplaceErrorType = MarketplaceErrorType.Unknown, message?: string) {
        super(message ?? MarketplaceErrorMessages[type]);

        this.type = type;
    }
}

export const MarketplaceErrorMessages: Record<MarketplaceErrorType, string> = {
    [MarketplaceErrorType.Unknown]: 'Oops, something went wrong.'
};
